import React from 'react'
import ReturnButton from '../../atoms/return-button/return-button'
import DynamicImage from '../../../shared/components/atoms/dynamic-image/dynamic-image'
import './header-event.scss'

const HeaderEvent = props => {
  const { urlDelVideo = '', returnUrl, image } = props

  return (
    <div className={'f-header-event ' + props.typeEvent}>
      <div className='f-header-event__back'>
        <ReturnButton href={returnUrl} />
      </div>

      <div className='f-header-event__content-wrapper'>
        <div className='f-header-event__content'>
          {image ? (
            <div className='f-header-event__content__image'>
              <DynamicImage
                className='image-fluid'
                loading='lazy'
                itemProp='image'
                image={image}
                alt={image?.description}
              />
            </div>
          ) : (
            <div className='f-header-event__content__video'>
              <iframe
                id='video'
                width='100%'
                height='100%'
                frameBorder='0'
                scrolling='no'
                src={
                  urlDelVideo.includes('youtube')
                    ? urlDelVideo.replace('watch?v=', 'embed/')
                    : urlDelVideo.includes('youtu.be')
                      ? urlDelVideo.replace('.be/', 'be.com/embed/')
                      : urlDelVideo
                }
                sandbox='allow-popups allow-same-origin allow-scripts allow-presentation'
                allow='microphone; camera; fullscreen'
                className='f-container-video-iframe'
                allowFullScreen
              />
            </div>
          )}
          <div className='f-header-event__content__description'>{props.children}</div>
        </div>
      </div>
    </div>
  )
}

export default HeaderEvent
